// extracted by mini-css-extract-plugin
export default {"contentText":"ContentText_contentText__aKig-","paragraph":"ContentText_paragraph__3kbyl"};